


























































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  LearningRequest as ILearningRequest,
  LearningRequestStatusEnum
} from "@/api/models/learning-request";
import { LearningRequestChangeStatus as ILearningRequestChangeStatus } from "@/api/models/learning-request-change-status";
import { availableStatuses, learningStatus } from "@/plugins/learning-status";
import { isRoot } from "@/plugins/roles";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import ListenerInRequestList from "@/components/orders/ListenerInRequestList.vue";
import api from "@/getinfo-api";
import CheckedUsersForInvite from "@/components/invite-users/CheckedUsersForInvite.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { isAllowEditDates, studentLimitModule } from "@/plugins/modules-detect";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import CourseRegistrationsTable from "@/components/courses/CourseRegistrationsTable.vue";
import store from "@/store";

@Component({
  components: {
    CourseRegistrationsTable,
    TextField,
    CBlock,
    CBreadCrumbs,
    CustomButton,
    CustomDatepicker,
    CheckedUsersForInvite,
    ListenerInRequestList
  },
  computed: {
    isAllowToEditDates: isAllowEditDates
  }
})
export default class OrderItem extends Vue {
  request!: ILearningRequest & { payload: { course_listeners: string[] } };
  orderStatus!: string;
  showSpinner: boolean = false;
  isShowFormedAt: boolean = false;
  isShowStartedAt: boolean = false;
  formedAt!: Date;
  startedAt!: Date | null;

  data() {
    return {
      request: undefined,
      formedAt: undefined,
      startedAt: undefined,
      orderStatus: undefined
    };
  }

  get isStudentLimitModule() {
    return studentLimitModule() && this.$store.state.studentLimit !== 0;
  }

  get isBlockAddStudent() {
    return (
      this.isStudentLimitModule &&
      this.$store.state.studentLimit - this.$store.state.studentAmount <
        this.request.users.length &&
      (this.request.status === LearningRequestStatusEnum.NotProcessed ||
        this.request.status === LearningRequestStatusEnum.WaitingPayment) &&
      this.request.resourceType !== "course2"
    );
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get documentManager() {
    return this.$store.getters.roles.includes("document_manager");
  }

  get currentEmployee() {
    let storageEmployee: any = localStorage.getItem("employee");
    return this.$store.getters.userIsEmployee &&
      this.$store.getters.userIsEmployee.id
      ? this.$store.getters.userIsEmployee.id
      : JSON.parse(storageEmployee).id;
  }

  get root() {
    return isRoot();
  }

  get checkCourse() {
    return this.request.resourceType === "course"
      ? this.request.resourceId
      : undefined;
  }

  get clientTypeFormatted() {
    let type: string = "";
    //@ts-ignore
    if (this.request.contractor.type === "physical") {
      type = `${this.$tc(this.$translate.PhysicalPerson)}`;
    }
    //@ts-ignore
    if (this.request.contractor.type === "juridical") {
      type = `${this.$tc(this.$translate.LegalPerson)}`;
    }
    return type;
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "orders" },
        label: `${this.$tc(this.$translate.LearningRequests)}`
      },
      {
        label: this.request.number
      }
    ];
  }

  get allStatuses() {
    return availableStatuses();
  }

  saveFormedAt() {
    api.LearningRequestApi.changeFormedAt(this.request.id, {
      formedAt: this.formedAt
    })
      .then(() => {
        this.isShowFormedAt = false;
        this.getRequest();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  saveStartedAt() {
    if (this.startedAt) {
      api.LearningRequestApi.changeStartedAt(this.request.id, {
        startedAt: this.startedAt
      })
        .then(() => {
          this.isShowStartedAt = false;
          this.getRequest();
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  formattedStatus(item: string) {
    return learningStatus(item);
  }

  get companyTitle() {
    return store.getters.selectedCompany.title;
  }

  getRequest() {
    api.LearningRequestApi.get(this.$route.params.orderId)
      .then((res: { data: ILearningRequest }) => {
        (this.request as ILearningRequest) = res.data;
        this.formedAt = this.request.formedAt;
        this.startedAt = this.request.startedAt ? this.request.startedAt : null;
        document.title = `${this.$t(this.$translate.LearningRequest)} ${
          this.request.number
        } | ${this.companyTitle}`;
        this.orderStatus = res.data.status;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  mounted() {
    this.getRequest();
  }

  getStudentActive() {
    api.CourseApi.listenersCountGlobal(this.request.companyId).then(res => {
      this.$store.state.studentAmount = +res.data;
    });
  }

  changeOrderStatus() {
    let params: ILearningRequestChangeStatus = {
      //@ts-ignore
      status: this.orderStatus,
      handle: true
    };
    api.LearningRequestApi.changeStatus(this.request.id, params)
      .then(() => {
        this.$bvToast.toast(`${this.$tc(this.$translate.Successful)}`, {
          variant: "success",
          title: `${this.$tc(this.$translate.Success)}`
        });
        if (
          params.status === "learning_finished" &&
          this.$store.getters["companyUtils/getIsFinishLearningWithEndLr"]
        ) {
          api.CourseApi.pass(
            this.request.resourceId,
            (this.request.payload.course_listeners as string[]).map(el => {
              return { listenerId: el, success: true };
            })
          );
        }

        this.getRequest();
        this.getStudentActive();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }
}
